export default __webpack_public_path__ + "static/media/spark_72.fad7283e.png";